// @flow
import React from "react";
import { connect, useSelector } from "react-redux";

import { Translate } from "@quantum/i18n";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
  SelecaoHorizonteDu,
  SelecaoConfianca,
  SelecaoVolatilidade,
  SelecaoLambda,
  SelecaoTipoDoRetorno,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  getVolatilidadeSelecionada,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { truncate } from "../../../util/index";

type Props = {
  exibirLambdaERetorno: boolean,
};

export const processarPeriodoComHcvl = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      lambda: edicaoMedida.lambda,
      horizonte: edicaoMedida.horizonte,
      confianca:
        edicaoMedida.confianca && truncate(edicaoMedida.confianca / 100, 2),
      volatilidade: edicaoMedida.volatilidade,
      tipoDoRetorno: edicaoMedida.tipoDoRetorno,
      janelaMovel: edicaoMedida.janelaMovel,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      periodicidade: edicaoMedida.periodicidade,
      ajusteDias: edicaoMedida.ajusteDias,
      lambda: edicaoMedida.lambda,
      horizonte: edicaoMedida.horizonte,
      confianca:
        edicaoMedida.confianca && truncate(edicaoMedida.confianca / 100, 2),
      volatilidade: edicaoMedida.volatilidade,
      tipoDoRetorno: edicaoMedida.tipoDoRetorno,
      dataBase: dataBase,
      janelaMovel: edicaoMedida.janelaMovel,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

function PeriodoComHcvl({ exibirLambdaERetorno }: Props) {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoHorizonteDu className="ConfiguracaoMedida__input--auto" />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoConfianca className="ConfiguracaoMedida__input--auto" />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVolatilidade />
            </div>
          </div>
        </div>

        {exibirLambdaERetorno ? <SelecaoLambda /> : null}
        {exibirLambdaERetorno ? <SelecaoTipoDoRetorno /> : null}

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--flex">
        <div className="ConfiguracaoMedida--flex">
          <SelecaoPeriodo exibirPeriodicidade={false} />
        </div>

        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoPeriodicidade />
          </div>

          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoHorizonteDu className="ConfiguracaoMedida__input--auto" />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoConfianca className="ConfiguracaoMedida__input--auto" />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVolatilidade />
            </div>
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoCasasDecimais />

        {exibirLambdaERetorno ? <SelecaoLambda /> : null}
        {exibirLambdaERetorno ? <SelecaoTipoDoRetorno /> : null}
      </div>
    );
  }
}

export default connect(
  state => ({
    exibirLambdaERetorno: getVolatilidadeSelecionada(state) === 1,
  }),
  null
)(PeriodoComHcvl);
